import React from "react";
import { Link } from "react-router-dom";

function Footer({ bg, text }) {
  return (
    <div className="print:hidden bg-white border-t border-gray-200">
      <footer className="body-font">
        <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between">
          <Link
            to="/"
            className="flex items-center gap-3"
            aria-label="Go to home page"
          >
            <img
              src="/image.png"
              alt="Patel Sangathan logo"
              className="w-12 h-12 rounded-xl shadow-lg"
            />
            <span className="text-2xl font-bold text-gray-900 tracking-wide">
              Patel Sangathan
            </span>
          </Link>
          <p className="text-sm text-gray-500 mt-4 md:mt-0 md:ml-6">
            © 2024 Patel Sangathan &mdash;{" "}
            <span className="font-mono text-blue-600">@patelsangathan</span>
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Footer;
